import * as React from 'react'
import { HistoryCardConnected } from './HistoryCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_B_ID } from 'mockState'

export const HistoryCardExamples = () => {
  return (
    <div className="HistoryCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <HistoryCardConnected taskId={MOCK_TASK_B_ID} />
      </Provider>
    </div>
  )
}
